export class PermissionM {
  id: number = 0;
  user_id: number = 0;
  course_module: boolean = false;
  course_payment: boolean = false;
  classroom_module: boolean = false;
  classroom_allocation: boolean = false;
  wallet_module: boolean = false;
  wallet_transfer: boolean = false;
  user_module: boolean = false;
  user_verify: boolean = false;
  purchase_module: boolean = false
  purchase_view: boolean = false
  purchase_edit: boolean = false
  purchase_approve: boolean = false
  purchase_cost_control: boolean = false
  purchase_manage_lost: boolean = false
  purchase_report_view:boolean = false
  purhase_delete_return_supplier = false
  purchase_delete_lost = false
  invoice_module: boolean = false
  invoice_view: boolean = false
  invoice_edit: boolean = false
  invoice_approve: boolean = false
  invoice_cost_control: boolean = false
  invoice_lock_date: boolean = false
  invoice_control_user_edit_past_date:boolean = false
  user_manage_module: boolean = false
  user_manage: boolean = false;
  user_manage_shipping_edit: boolean = false
  user_manage_shipping_view: boolean = false
  user_manage_customer_edit: boolean = false
  user_manage_customer_view: boolean = false
  user_manage_admin_edit: boolean = false
  user_manage_admin_view: boolean = false
  user_statement_module: boolean = false
  user_statement_view: boolean = false
  user_statement_edit: boolean = false

  payment_module: boolean = false
  payment_view: boolean = false
  payment_edit: boolean = false
  payment_approve: boolean = false

  refund_module: boolean = false
  refund_create: boolean = false
  refund_approve: boolean = false
  refund_save_return: boolean = false



}



// WEBPACK FOOTER //
// ./src/app/model/permission.model.ts